import React, { useState, useRef, useEffect } from 'react';
import './services/api';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Calendar from './components/Calendar/Calendar';
import Form from './components/Form/Form';
import Doctors from './components/Doctors/Doctors';
import Hospitals from './components/Hospitals/Hospitals';
import HospitalSlots from './components/HospitalSlots/HospitalSlots';
import Availability from './components/Availability/Availability';
import Analytics from './components/Analytics/Analytics';
import Settings from './components/Settings/Settings';
import './App.css';
import './styles/shared-ui.css';
import './components/common/AppIcon.css';

const App = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const calendarRef = useRef(null);

  const handleAddEvent = (newEvent) => {
    setEvents([...events, newEvent]);
  };

  const handleDateClick = (arg) => {
    console.log('Date clicked:', arg);
  };

  const refreshCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.refreshEvents();
    }
  };

  const handleToday = () => {
    // Scroll to today's date or highlight it
    console.log('Today button clicked');
  };

  const [tab, setTab] = useState('schedule');

  useEffect(() => {
    const updateTab = () => {
      const h = window.location.hash.replace('#', '') || 'schedule';
      setTab(h);
    };
    updateTab();
    window.addEventListener('hashchange', updateTab);
    return () => window.removeEventListener('hashchange', updateTab);
  }, []);

  const renderMain = () => {
    if (tab === 'doctors') return <Doctors />;
    if (tab === 'hospitals') return <Hospitals />;
    if (tab === 'slots') return <HospitalSlots />;
    if (tab === 'availability') return <Availability />;
    if (tab === 'analytics') return <Analytics />;
    if (tab === 'settings') return <Settings />;
    return (
      <>
        <div className="main-content">
          <Calendar 
            ref={calendarRef} 
            events={events} 
            handleDateClick={handleDateClick}
            onToday={handleToday}
          />
          <Form 
            onAddEvent={handleAddEvent} 
            setLoading={setLoading} 
            setSuccess={setSuccess} 
            refreshCalendar={refreshCalendar}
          />
        </div>
      </>
    );
  };

  return (
    <div className="app">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <div className="loading-text">Processing your request...</div>
        </div>
      )}
      
      <Header />
      
      {renderMain()}
      
      <Footer />
      
      {success && (
        <div className="success-notification">
          ✅ Shift scheduled successfully!
        </div>
      )}
      
      {error && (
        <div className="error-notification">
          ❌ {error}
        </div>
      )}
    </div>
  );
};

export default App;
